import * as React from 'react';
import { UserRole } from 'stageclip-common';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { AppSelectField } from '../form/appSelectField';
import { AppTextField } from '../form/appTextField';
import { email, required } from '../form/formValidations';

import Button from 'components/buttons/button';
import * as PermissionsHelper from 'helpers/permissionsHelper';
import { createModalCloseAction, createModalOpenAction } from 'actions/modalActions';
import { FormId } from 'constants/formId';
import { SimpleModalId } from 'constants/modalId';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { baseMapStateToProps, BaseStateProps } from 'components/componentBase';
import { DeleteUserModalProps } from 'components/deleteUserModal/DeleteUserModal.types';
import styles from './baseUserForm.module.scss';

type BaseUserFormProps = {
  formId: FormId.EditUserForm | FormId.CreateUserForm;
  openDeleteUserModal: (user: DeleteUserModalProps) => void;
  closeEditUserModal: () => void;
  user: DeleteUserModalProps;
} & BaseStateProps;

// eslint-disable-next-line react/prefer-stateless-function
class BaseUserForm extends React.Component<BaseUserFormProps> {
  public render() {
    const roles = Object.keys(UserRole).map(role => ({ value: role, label: role }));
    const {
      formId,
      openDeleteUserModal,
      user,
      closeEditUserModal,
      currentUser: { id },
    } = this.props;

    const showDeleteButton =
      PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.DeleteUser) &&
      formId === FormId.EditUserForm &&
      user.id !== id;

    return (
      <>
        <AppTextField name="firstName" label="First Name" validate={[required]} />
        <AppTextField name="lastName" label="Last Name" validate={[required]} />
        <AppTextField name="email" label="Email" validate={[required, email]} />
        <AppSelectField name="role" label="Role" validate={[required]} options={roles} />
        {showDeleteButton && (
          <>
            <Button
              className={styles.deleteButton}
              type="button"
              onClick={() => {
                openDeleteUserModal(user);
                closeEditUserModal();
              }}
              text="Delete"
              allCapitals
              icon={faTrash}
            />
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: ClippingPlatformState, ownProps: { formId: BaseUserFormProps['formId'] }) => {
  const user = get(state.appStatus.modals, [ownProps.formId, 'props'], {});

  return {
    ...baseMapStateToProps(state),
    user,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openDeleteUserModal: (data: DeleteUserModalProps) => {
    dispatch(createModalOpenAction(SimpleModalId.DeleteUser, data));
  },
  closeEditUserModal: () => {
    dispatch(createModalCloseAction(FormId.EditUserForm));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BaseUserForm);
